import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class AiAssistantService {

  constructor(private http: HttpClient) { }

  getTripChatLogs(tripId: string): Observable<any> {
    const signature = CryptoJS.HmacSHA256(
      JSON.stringify({}),
      environment.HMAC_CONVERSATION_SECRET
    ).toString(CryptoJS.enc.Hex);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-hmac-signature': signature,
      'ngrok-skip-browser-warning': 'true'
    });

    return this.http.get<any>(
      urls.OUTBOUND_CONVERSATION_BASE_URL + urls.OUTBOUND_CONVERSATION + tripId,
      { headers }
    ).pipe(catchError(errorHandl));
  }

  getRecording(post: any) {
    const signature = CryptoJS
      .HmacSHA256(JSON.stringify(post), environment.HMAC_CONVERSATION_SECRET)
      .toString(CryptoJS.enc.Hex);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-hmac-signature': signature,

    });

    return this.http.post<any>(
      `${urls.OUTBOUND_CONVERSATION_BASE_URL}records/trip/recording/s3`, post, { headers }
    ).pipe(
      catchError(errorHandl)
    );
  }
}
